@if (isEmbedded()) {
    <div class="sir-iframe-container">
        <iframe
            #iframe
            [src]="safeVideoUrl()"
            [title]="title()"
            width="100%"
            height="100%"
            scrolling="no"
            allowfullscreen
            (load)="onLoaded()">
        </iframe>
    </div>
} @else {
    <div class="sir-video-item-frame">
        <video
            #videoelement
            [controls]="isInit()"
            [src]="videoUrl()"
            preload="metadata"
            [attr.poster]="thumbnailUrl()"
            [attr.aria-label]="title()"
            [class.is-contain]="objectFit() === 'contain'"
            [class.is-cover]="objectFit() === 'cover'"
            [class.is-fill]="objectFit() === 'fill'"
            [class.is-scale-down]="objectFit() === 'scale-down'"
            (loadedmetadata)="onLoaded()"></video>

        @if (!isPlaying()) {
            <sirius-play-button [hovered]="isHovered()"></sirius-play-button>
        }
    </div>
}
